/**
 * AJAX Pagination Handler for Calendar
 * Prevents page reload and updates events list dynamically
 */

export function initPaginationHandler() {
  // Use event delegation on document for dynamically loaded pagination links
  document.addEventListener('click', async (e) => {
    // Check if clicked element is a pagination link
    const paginationLink = e.target.closest('.pagination a');
    if (!paginationLink) return;

    // Only handle if we're in list view
    const calendarList = document.querySelector('.calendar-list');
    if (!calendarList || calendarList.classList.contains('hide')) return;

    e.preventDefault();

    const url = new URL(paginationLink.href);
    // Add ajax parameter
    url.searchParams.set('ajax', '1');

    try {
      // Show loading state
      calendarList.style.opacity = '0.5';
      calendarList.style.pointerEvents = 'none';

      // Fetch new page content
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error('Failed to load events');

      const html = await response.text();

      // Create temporary container to parse HTML
      const temp = document.createElement('div');
      temp.innerHTML = html;

      // Find the new calendar section and pagination
      const newCalendarSection = temp.querySelector('#calendar-section');
      const newPagination = temp.querySelector('.pagination-container');

      if (newCalendarSection) {
        // Replace calendar list
        const currentSection = document.querySelector('#calendar-section');
        if (currentSection) {
          currentSection.replaceWith(newCalendarSection);
        }

        // Replace pagination
        const currentPagination = document.querySelector('.pagination-container');
        if (currentPagination && newPagination) {
          currentPagination.replaceWith(newPagination);
        } else if (newPagination) {
          // Add pagination if it didn't exist
          newCalendarSection.after(newPagination);
        } else if (currentPagination && !newPagination) {
          // Remove pagination if no longer needed
          currentPagination.remove();
        }

        // Scroll to calendar section smoothly
        newCalendarSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Update URL without reload
        const newUrl = paginationLink.href;
        window.history.pushState({ page: url.searchParams.get('page') }, '', newUrl);

        // Notify other modules that the list DOM has been replaced
        document.dispatchEvent(new CustomEvent('calendarListUpdated', { detail: { section: newCalendarSection } }));
      }
    } catch (error) {
      console.error('Pagination error:', error);
      // Fallback to regular navigation
      window.location.href = paginationLink.href;
    }
  });

  // Handle browser back/forward buttons
  window.addEventListener('popstate', () => {
    // Reload page on back/forward (simple approach)
    window.location.reload();
  });
}
